<template>
  <StLogin
    v-if="loadingUniverseEnvironment"
    :loading="loading"
    :i18n="i18n"
    @login="login"
  />
</template>

<script>
import StLogin from '@stilingue/st-login';
import has from 'lodash.has';
import { mapActions } from 'vuex';

export default {
  name: 'LoginView',
  components: {
    StLogin,
  },
  props: {
    accountId: {
      type: String,
      default: '',
    },
    universeId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loadingUniverseEnvironment: false,
      loading: false,
    };
  },
  computed: {
    i18n() {
      return {
        email: this.$t('LoginView.email'),
        password: this.$t('LoginView.password'),
        enter: this.$t('LoginView.enter'),
        emailIsRequired: this.$t('LoginView.emailIsRequired'),
        emailIsInvalid: this.$t('LoginView.emailIsInvalid'),
        passwordIsRequired: this.$t('LoginView.passwordIsRequired'),
      };
    },
    genericErrorMsg() {
      return this.$t('LoginView.genericErrorMsg');
    },
    specificErrors() {
      return {
        'Not Found': this.$t('LoginView.notFound'),
        'Unauthorized': this.$t('LoginView.Unauthorized'),
        'No Token Received': this.$t('LoginView.genericErrorMsg'),
      };
    },
  },
  async created() {
    if (this.universeId) {
      await this.getIfUniverseIsStaging(this.universeId);
      this.loadingUniverseEnvironment = true;
    }
  },
  methods: {
    ...mapActions('user', [
      'makeLoginRequest',
    ]),
    ...mapActions('dashboard', [
      'getIfUniverseIsStaging',
    ]),
    login({ username, password }) {
      this.loading = true;

      this
        .makeLoginRequest({
          username,
          password,
        })
        .then(this.handleLoginSuccess)
        .catch(this.handleError);
    },
    handleLoginSuccess() {
      if (!(this.accountId && this.universeId)) {
        this.$router.push({
          name: 'error',
          params: {
            errorStatus: '405',
          },
        });

        return false;
      }

      this.$router.push({
        name: 'home',
        params: {
          accountId: this.accountId,
          universeId: this.universeId,
        },
      });
    },
    handleError(data) {
      console.warn(data);

      let errorMsg = this.genericErrorMsg;
      if (has(data, 'response.data.error') && data.response.data.error in this.specificErrors) {
        errorMsg = this.specificErrors[data.response.data.error];
      }

      this.loading = false;
      this.$noty.error(errorMsg);

      return errorMsg;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
